

/**
 * A function that prevents event thrashing by throttling the actual call of
 * the function
 */
export default function(func, wait) {
  var timeout;

  return function() {
    var context = this;
    var args = arguments;

    if (! timeout) {
      timeout = window.setTimeout(function() {
        timeout = null;
        func.apply(context, args);
      }, wait);
    }
  };
}

